import { useEffect } from 'react';
import { useGlobalStore } from '@/stores';
import { AffiliateLinksTable, useMyAffiliateLinks } from '@/features/affiliate-links';

export default function AffiliateLinksPage() {
    const setBreadcrumbs = useGlobalStore(state => state.setBreadcrumbs);
    const { data: links, isLoading } = useMyAffiliateLinks();

    useEffect(() => {
        setBreadcrumbs([{ title: 'My Affiliate Links', to: '/affiliate', active: true, id: 'affiliate' }]);
    }, [setBreadcrumbs]);

    return (
        <div className='flex w-full flex-col gap-6'>
            <AffiliateLinksTable links={links ?? []} isLoading={isLoading} />
        </div>
    );
}
